import React, { useState } from "react";
import { Button, Form, notification } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import { createDeal } from "../../../api";
import ProjectBasicsFields, {
  buildProjectBasicsFormData
} from "../../../pages/DataRoom/components/ProjectBasicsFields";

/**
 * Creates a Data Room project from the few fields the project record needs,
 * then hands the new project over so the caller can open its editor. All the
 * dashboard content is authored in the editor itself, and these fields stay
 * editable there under Project settings.
 */
const DataRoomQuickCreateForm = ({ onBack, onCreated }) => {
  const [form] = Form.useForm();
  const [logo, setLogo] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleFinish = async (values) => {
    const formData = buildProjectBasicsFormData(values, logo);
    formData.append("layout", "dataroom");
    formData.append("platform", window.location.origin);

    setSubmitting(true);
    try {
      const { data } = await createDeal(null, formData);
      // Upload errors come back as a 200 with no project.
      if (!data?.project?._id) {
        throw new Error(data?.message || "The project could not be created");
      }
      onCreated(data.project);
    } catch (error) {
      notification.error({
        message: error?.response?.data?.message || error?.message || "The project could not be created"
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form form={form} layout="vertical" requiredMark={false} onFinish={handleFinish}>
      <p className="project-basics-intro">
        Start with the basics. You will go straight to the Data Room editor to add the content.
      </p>

      <ProjectBasicsFields onLogoChange={setLogo} />

      <div className="project-basics-actions">
        <Button type="text" icon={<ArrowLeftOutlined />} onClick={onBack} disabled={submitting}>
          Back
        </Button>
        <Button type="primary" htmlType="submit" loading={submitting}>
          Create and open editor
        </Button>
      </div>
    </Form>
  );
};

export default DataRoomQuickCreateForm;
